import React, { createContext, useContext, useState, useCallback } from 'react';

// Create the EliteGames Context
const EliteGamesContext = createContext();

// Custom hook to use the EliteGames context
export const useEliteGames = () => {
  const context = useContext(EliteGamesContext);
  if (!context) {
    throw new Error('useEliteGames must be used within an EliteGamesProvider');
  }
  return context;
};

// EliteGames Provider Component
export const EliteGamesProvider = ({ children }) => {
  // Global state for Elite Games
  const [globalState, setGlobalState] = useState({
    selectedCategory: null,
    selectedSubCategory: null,
    selectedQuestion: null,
    refreshData: false,
    loading: false,
    error: null,
    currentQuizType: null,
    currentPage: 1,
    searchFilters: {},
    title: ''
  });

  // Action creators

  const setLoading = useCallback((loading) => {
    setGlobalState((prev) => ({
      ...prev,
      loading
    }));
  }, []);

  const resetState = useCallback(() => {
    setGlobalState({
      selectedCategory: null,
      selectedSubCategory: null,
      selectedQuestion: null,
      refreshData: false,
      loading: false,
      error: null,
      currentQuizType: null,
      currentPage: 1,
      searchFilters: {}
    });
  }, []);

  // Set title function
  const setTitle = useCallback((title) => {
    setGlobalState((prev) => ({
      ...prev,
      title
    }));
  }, []);

  // Utility functions

  // Context value
  const contextValue = {
    // State
    ...globalState,

    // Actions

    setLoading,
    resetState,
    setTitle
  };

  return <EliteGamesContext.Provider value={contextValue}>{children}</EliteGamesContext.Provider>;
};

export default EliteGamesContext;
